var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item",on:{"click":function($event){return _vm.$emit('click')}}},[_c('i',{staticClass:"item-icon fa",class:( _obj = {}, _obj[_vm.clsIcon] = true, _obj )}),_c('div',{staticClass:"item-text"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }